import axiosInstance from "../utils/axios";

class ApiService {
    /**
     * GET Request
     * @param {string} url 
     * @param {object} params 
     * @param {object} options Additional axios config
     * @returns {Promise}
     */
    async get(url, params = {}, options = {}) {
        try {
            const response = await axiosInstance.get(url, { params, ...options });
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * POST Request
     * @param {string} url 
     * @param {object} data 
     * @param {object} options Additional axios config
     * @returns {Promise}
     */
    async post(url, data = {}, options = {}) {
        try {
            const response = await axiosInstance.post(url, data, options);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * PUT Request
     * @param {string} url 
     * @param {object} data 
     * @param {object} options Additional axios config
     * @returns {Promise}
     */
    async put(url, data = {}, options = {}) {
        try {
            const response = await axiosInstance.put(url, data, options);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * PATCH Request
     * @param {string} url 
     * @param {object} data 
     * @param {object} options Additional axios config
     * @returns {Promise}
     */
    async patch(url, data = {}, options = {}) {
        try {
            const response = await axiosInstance.patch(url, data, options);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * DELETE Request
     * @param {string} url 
     * @param {object} options Additional axios config
     * @returns {Promise}
     */
    async delete(url, options = {}) {
        try {
            const response = await axiosInstance.delete(url, options);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Handle Multipart/Form-data (e.g. for uploads)
     * @param {string} url 
     * @param {FormData} formData 
     * @param {string} method defaults to POST
     * @returns {Promise}
     */
    async upload(url, formData, method = 'post') {
        try {
            const response = await axiosInstance({
                method: method,
                url: url,
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

const apiService = new ApiService();
export default apiService;
